export function useWatsonAssistant() {
  const initWatsonAssistant = () => {
    if (window.watsonAssistantChatLoaded || window.watsonAssistantChatLoading) {
      return;
    }

    const chatScriptUrl = window.watsonAgentData?.chatScriptUrl;
    const chatStylesheetUrl = window.watsonAgentData?.chatStylesheetUrl;

    if (!chatScriptUrl || !chatStylesheetUrl) {
      return;
    }

    window.watsonAssistantChatLoading = true;
    window.s2pChatbotFullscreen = false;
    window.openChatByDefault = false;

    if (!document.querySelector(`link[href="${chatStylesheetUrl}"]`)) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = chatStylesheetUrl;
      document.head.appendChild(stylesheet);
    }

    const script = document.createElement('script');
    script.src = chatScriptUrl;
    script.defer = true;
    script.onload = () => {
      window.watsonAssistantChatLoaded = true;
      window.watsonAssistantChatLoading = false;
    };
    script.onerror = () => {
      window.watsonAssistantChatLoading = false;
    };
    document.head.appendChild(script);
  };

  return {
    initWatsonAssistant
  };
}